export class RedirectError extends Error {
  constructor(message: string, private _redirectUrl: string) {
    super(message);
  }

  get redirectUrl() {
    return this._redirectUrl;
  }
}

export class MissingDataError extends Error {
  constructor(message: string) {
    super(message);
  }
}
